import { render, staticRenderFns } from "./DeviceAlarmView.vue?vue&type=template&id=13a632be"
import script from "./DeviceAlarmView.vue?vue&type=script&lang=js"
export * from "./DeviceAlarmView.vue?vue&type=script&lang=js"
import style0 from "./DeviceAlarmView.vue?vue&type=style&index=0&id=13a632be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports